import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { errorMessage } from '../api/client';
import { useAuthConfig, useAuthMutations } from '../api/hooks';
import { AuthFrame } from '../components/AuthFrame';
import { Field } from '../components/Field';
import { de } from '../i18n/de';

/** Anmelden; danach geht es weiter, wohin man wollte (`?next=`, sonst die Übersicht – das erledigt `PublicOnly`). */
export function LoginPage() {
  const { login, devLogin } = useAuthMutations();
  const { data: cfg } = useAuthConfig();
  const [params] = useSearchParams();
  const next = params.get('next');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = (e: FormEvent): void => {
    e.preventDefault();
    login.mutate({ email, password });
  };

  return (
    <AuthFrame title={de.auth.loginTitle}>
      {next && <div className="muted small">{de.auth.loginRequired}</div>}
      <form className="col auth-form" onSubmit={submit}>
        <Field label={de.auth.email}>
          <input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </Field>
        <Field label={de.auth.password}>
          <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        {login.isError && (
          <div className="error-text" role="alert">
            {errorMessage(login.error)}
          </div>
        )}
        <button className="btn primary" type="submit" disabled={login.isPending} data-testid="login-submit">
          {de.auth.login}
        </button>
      </form>
      <div className="auth-links">
        {cfg?.passwordReset && <Link to="/reset">{de.auth.forgot}</Link>}
        {cfg && cfg.registration !== 'closed' && (
          <span>
            {de.auth.noAccount} <Link to={next ? `/register?next=${encodeURIComponent(next)}` : '/register'}>{de.auth.register}</Link>
          </span>
        )}
      </div>
      {cfg?.devLogin && (
        <button type="button" className="btn ghost small" onClick={() => devLogin.mutate()} disabled={devLogin.isPending} data-testid="dev-login">
          {de.auth.devLogin}
        </button>
      )}
    </AuthFrame>
  );
}
